import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { Button } from '@common/Button';
import { ShareSurveyModal } from '../../../survey/share/ShareSurveyModal';
import { useSurvey } from '@contexts/SurveyContext';

export const ShareTab = () => {
  const { activeSurvey } = useSurvey();
  const [showShare, setShowShare] = useState(false);

  return (
    <div className="p-4 space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-medium text-white mb-2">Share Survey</h3>
        <p className="text-sm text-gray-400">
          Share this survey with team members or generate a shareable link
        </p>
      </div>

      <Button
        onClick={() => setShowShare(true)}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white flex items-center justify-center gap-2"
      >
        <Share2 className="w-4 h-4" />
        Share Survey
      </Button>

      {showShare && activeSurvey && (
        <ShareSurveyModal
          isOpen={showShare}
          onClose={() => setShowShare(false)}
          survey={activeSurvey}
        />
      )}
    </div>
  );
};

export default ShareTab